import { ReactElement } from "react";
import Section, {
  DisplaySectionType,
  GeometrySectionType,
  HiddenSectionType,
} from "../../types/Section";
import GeometryControl from "./controls/GeometryControl";
import InputSectionRenderer from "./InputSectionRenderer";
import "./SectionRenderer.scss";

interface SectionRendererProps {
  section: Section;
}

function SectionRenderer({
  section,
}: SectionRendererProps): ReactElement | null {
  switch (section.type) {
    case DisplaySectionType.heading:
      return <h2>{section.content}</h2>;

    case DisplaySectionType.text:
      return (
        <div
          className="rich-text"
          dangerouslySetInnerHTML={{ __html: section.content }}
        />
      );

    case DisplaySectionType.image:
      return <img className="display-image" src={section.content} alt="" />;

    case GeometrySectionType.geometry_point:
    case GeometrySectionType.geometry_line:
    case GeometrySectionType.geometry_polygon:
      return (
        <GeometryControl
          type={section.type}
          id={section.columnName}
          label={section.label}
          info={section.helpText}
          required={section.required}
          basemap={section.basemap}
          extent={section.extent}
        />
      );

    case HiddenSectionType.datetime:
    case HiddenSectionType.dictionary:
    case HiddenSectionType.foreign_key:
    case HiddenSectionType.multiselect_dictionary:
    case HiddenSectionType.uuid:
      return <>-</>;

    default:
      return <InputSectionRenderer id={section.columnName} section={section} />;
  }
}

export default SectionRenderer;
